<template>
  <div id="form-slideshow-add">
    <div class="vs-editor-canvas">
      <template>
        <Draggable v-for="(each) of items.slice().reverse()" :key="each.id" :item="each" :ratio="ratio"/>
      </template>
    </div>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>
<script>

import {USER_NAME} from '../constant';
import Draggable from "./Draggable";
import BaseFormLoading from "./base/BaseFormLoading";

export default {
  name: 'Player',
  components: {Draggable, BaseFormLoading},
  data: function () {
    return {
      loading: {value: false},
      typeLayer: null,
      items: [],
      ratio: null
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loading.value = true;
    this.$sendMessageSocket("/app/devices/getSchedule", localStorage.getItem(USER_NAME), {});
  },
  methods: {},
  watch: {
    '$store.state.messageSocket': function (value) {
      this.loading.value = false;
      var widthScreen = $(window).width();
      var heightScreen = $(window).height();
      var widthRatio = value.widthDesign / widthScreen;
      var heightRatio = value.heightDesign / heightScreen;
      if (value != null && (value.draggableModels != null && value.draggableModels.length > 0)) {
        value.draggableModels.map(each => {
          // if (each.extractData.type === TypeChooseLayer.IMAGE) {
          //   var calculateTransform = {
          //     width: each.transform.width / (1344.6562 / widthScreen),
          //     height: each.transform.height / (664 / heightScreen),
          //     x: each.transform.x / widthRatio,
          //     y: each.transform.y / heightRatio,
          //     rotation: each.transform.rotation
          //   }
          // } else {
          var calculateTransform = {
            width: each.transform.width / widthRatio,
            height: each.transform.height / heightRatio,
            x: each.transform.x / widthRatio,
            y: each.transform.y / heightRatio,
            rotation: each.transform.rotation
          }
          // }
          each.transform = calculateTransform;
        })
        this.items = value.draggableModels;
        this.ratio = value.ratio;
      }
    }
  },
  destroyed() {
  }
}
</script>

<style scoped>
/*video {*/
/*  object-fit: cover;*/
/*}*/
</style>
<style>
body {
  pointer-events: none;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/Player.vue